<template>
  <div class="input-group" :class="{'disabled': disabled, 'read-only': isReadOnly, 'fault': hasError}">
    <div class="input">
      <label>{{label}}</label>
      <input ref="theinput" v-if="autowidth" v-autowidth="{maxWidth: '960px', minWidth: '20px', comfortZone: 0}" :value="value" :disabled="disabled" :type="type" :readonly="preventEdit" :placeholder="placeholder" @input="(ev) => $emit('input', ev.target.value)" />
      <input ref="theinput" v-else :value="value" :disabled="disabled" :type="type" :step="step" :readonly="preventEdit" :placeholder="placeholder" @input="(ev) => $emit('input', ev.target.value)" />
      <p v-if="showHint || haserror" class="extra "><slot/></p>
    </div>
  </div>
</template>

<script>
/* eslint-disable */

export default {
    props: {
        label: String,
        step: Number,
        placeholder: String,
        value: [String, Number],
        disabled: Boolean,
        readonly: Boolean,
        name: String,
        autofocus: Boolean,
        haserror: Boolean,
        showHint: {
            type: Boolean,
            default: false
        },
        readonlySimple: Boolean, // only disables the input, without turning it into a label
        autowidth: {
            type: Boolean,
            default: false
        },
        type: {
            default: "search"
        }
    },
    data() {
        return {
            setReadOnly: false
        };
    },
    methods: {
        focus() {
            this.$nextTick(() => this.$refs.theinput.focus());
        },
        blur() {
            this.$nextTick(() => this.$refs.theinput.blur());
        },
        changeReadOnly(newValue) {
            this.setReadOnly = newValue;
        }
    },
    computed: {
        hasError() {
            return this.haserror && !this.readonly;
        },
        preventEdit() {
            if (this.isReadOnly === true) {
                return true;
            }
            if (this.readonlySimple === true) {
                return true;
            }
            return false;
        },
        isReadOnly() {
            if (this.readonly === true || this.setReadOnly === true) {
                return true;
            }
            return false;
        }
    }
};
</script>

<style lang="less">
@import (reference) "~@/assets/less/general.less";

// size
@input-border-radius: 7px;
@input-height: 60px;
@input-margin-right: 20px;
@input-min-width: none;

.input-group {
    @border-radius: @input-border-radius;

    .input-group.width-100;
    text-align: left;
    position: relative;
    font-size: 0;

    &:not(:last-child) {
        margin-bottom: 30px;
    }

    &.read-only {
        .input {
            label {
                .fontsize-s;
                .font-regular;
                color: @gray-mid;
                margin: 5px 0;
            }

            input {
                .no-select;
                .font-regular;
                .fontsize-s;
                line-height: 19px;
                border: none;
                padding: 0;
                height: auto;
                cursor: default;
                background-color: transparent;

                &:focus,
                &:hover {
                    background-color: transparent;
                    border: none;
                    color: @input-text;
                }
            }
        }
    }

    &.fault .input {
        input {
            background-color: @input-fault-bg;
            border: 1px solid @input-fault-border;
            color: @input-fault-text;

            &:focus,
            &:hover {
                background-color: @input-fault-bg;
                border: 1px solid @input-fault-border;
                color: @input-fault-text;
            }
        }

        .extra {
            //display: block;
        }
    }

    .input {
        .lh-display(flex);
        .lh-align-items(center);
        .lh-flex-wrap(wrap);
        width: 100%;

        > label {
            .lh-flex(0 0 160px);
            .fontsize-s;
            margin-bottom: 10px;
            display: block;

            &:empty {
                display: none;
            }
        }

        input {
            .lh-flex(1);
            .lh-transition(all @anim-duration cubic-bezier(0, 0.5, 0.5, 1));
            .lh-appearance(none);
            .lh-box-sizing(border-box);
            .fontsize-m;
            .font-regular;
            height: @input-height;
            background-color: @input-bg;
            border: 1px solid @input-border;
            color: @input-text;
            border-radius: @input-border-radius;
            padding: 0 15px;
            width: 100%;
            cursor: text;

            &:focus,
            &:hover {
                background-color: @input-focus-bg;
                border: 1px solid @input-focus-border;
                color: @input-focus-text;
            }
        }

        .extra {
            .lh-flex(0 0 100%);
            .fontsize-xs;
            color: @input-extra-text;
            padding-top: 10px;

            &:empty {
                display: none;
            }
        }
    }

    .input-unit {
        color: @input-unit;
        position: absolute;
        bottom: 0;
        text-align: right;
        right: 0;
        top: auto;
        bottom: 0;
        left: auto;
        line-height: @input-height - 2px;
        width: 60px;
        z-index: 999;
        display: block;
    }
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill,
select:-webkit-autofill,
select:-webkit-autofill:hover,
select:-webkit-autofill:focus {
    color: @input-text !important;
    background-color: @input-bg !important;
    -webkit-text-fill-color: @input-text;
    -webkit-box-shadow: 0 0 0px 1000px @input-bg inset;
    transition: @input-bg 0.1s ease-in-out 0s;
}

::-webkit-input-placeholder {
    color: @input-placeholder-text;
    .font-regular;
}
::-moz-placeholder {
    color: @input-placeholder-text;
    .font-regular;
}
:-ms-input-placeholder {
    color: @input-placeholder-text;
    .font-regular;
}
:-moz-placeholder {
    color: @input-placeholder-text;
    .font-regular;
}
::placeholder {
    color: @input-placeholder-text;
    .font-regular;
}

// Extra classes
.input-group.one-column,
.input-group.width-100 {
    width: 100%;
}
.input-group.two-column {
    .lh-calc(width, ~"50% - @{input-margin-right}");
}
.input-group.three-column {
    .lh-calc(width, ~"33% - @{input-margin-right}");
}
.input-group.inline {
    display: inline-block;
    vertical-align: top;
    margin-bottom: 0;

    &:not(:only-child):not(:last-child) {
        margin-right: @input-margin-right;
    }

    .input {
        display: inline-block;
        vertical-align: top;
    }
}
</style>
